// dependencies
import React from "react";
import { StyleSheet, css } from "aphrodite";
import { useIntl } from "react-intl";

// components
import BaseComponent from "@cloudspire/legacy-resources/src/components/BaseComponent2";
import ConditionalWrapper from "@cloudspire/shared/components/ConditionalWrapper";
import Link from "../Link";

// contexts
import { useRouters } from "../../contexts/routers";

// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";
// constants
import {
  HOTEL_RATING_CITY_BREAK_INTL_MESSAGES,
  HOTEL_RATING_CITY_BREAKS,
} from "@cloudspire/shared/constants/hotel/rating";

const styles = StyleSheet.create({
  citybreak: {
    display: "inline-flex",
    justifyContent: "flex-start",
  },
  label: {
    backgroundColor: "rgb(129, 74, 151)",
    color: "#ffffff",
    fontSize: "0.625rem",
    textTransform: "uppercase",
    padding: "0.1875rem",
    borderRadius: "0.1875rem",
  },
});

type PropsType = {
  value: keyof typeof import("@cloudspire/shared/constants/hotel/rating").HOTEL_RATING_CITY_BREAKS;
  aStyle?;
  shouldAddSearchLink?: boolean;
};

function RoomRankingsCitybreak(props: PropsType) {
  const { value, aStyle, shouldAddSearchLink } = props;

  const intl = useIntl();

  const { frontRouter } = useRouters();

  const cityBreakInfo = HOTEL_RATING_CITY_BREAKS[value];

  return (
    <ConditionalWrapper
      hasWrapper={shouldAddSearchLink}
      wrapper={(children) => (
        <Link
          to={generateUri({
            router: frontRouter,
            name: "App.Action.RoomList",
            parameters: {
              lang: intl.locale,
            },
            query: {
              epi: String(cityBreakInfo.epiValue),
            },
          })}
        >
          {children}
        </Link>
      )}
    >
      <BaseComponent aStyle={styles.citybreak}>
        <div className={css(styles.label, aStyle)}>
          {intl.formatMessage(
            HOTEL_RATING_CITY_BREAK_INTL_MESSAGES.byValue[value].label
          )}
        </div>
      </BaseComponent>
    </ConditionalWrapper>
  );
}

export default RoomRankingsCitybreak;
